import React from "react";

export default function checkmark(props) {
  return (
    <svg id="checkmark" viewBox="0 0 32 32" {...props}>
      <path d="M11.787 26.367c-.61 0-1.22-.232-1.685-.697l-8.427-8.428a2.383 2.383 0 1 1 3.371-3.371l6.741 6.742L26.955 5.445a2.383 2.383 0 1 1 3.371 3.371L13.472 25.67a2.377 2.377 0 0 1-1.685.697" />
    </svg>
  );
}
